import ActionTypes from '../constants';

const initialState = {
    jobCards: {},
    allJobCards: {},
    parallelJobCards: {},
    jobCard: {},
    jobCardId: {},
    savedJobCard: {},
    saleOrderInsurance: {},
    saleOrderCustomer: {},
    jobCardByInsuranceCompanyId: {}
    // loading: false,
};

const jobCardReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETJOBCARDSUCCESS:
            return {
                ...state,
                jobCards: action.payload,
            }
        case ActionTypes.GETALLJOBCARDSUCCESS:
            return {
                ...state,
                allJobCards: action.payload,
            }
        case ActionTypes.GETPARALLELJOBCARDSUCCESS:
            return {
                ...state,
                parallelJobCards: action.payload,
            }
        case ActionTypes.GETJOBCARDIDSUCCESS:
            return {
                ...state,
                jobCardId: action.payload,
            }
        case ActionTypes.GETJOBCARDBYIDSUCCESS:
            return {
                ...state,
                jobCard: action.payload,
            }
        case ActionTypes.GETJOBCARDBYINSURANCEIDSUCCESS:
            return {
                ...state,
                saleOrderInsurance: action.payload,
            }
        case ActionTypes.GETJOBCARDBYCUSTOMERIDSUCCESS:
            return {
                ...state,
                saleOrderCustomer: action.payload,
            }
        case ActionTypes.GETJOBCARDBYESTIMATEIDSUCCESS:
            return {
                ...state,
                savedJobCard: action.payload,
            }
        case ActionTypes.GETJOBCARDBYINSURANCECOMPANYIDSUCCESS:
            return {
                ...state,
                jobCardByInsuranceCompanyId: action.payload,
            }
        default:
            return state;
    }
}

export default jobCardReducer;